import {Link as RouterLink} from 'react-router-dom';
import {Link} from '@mui/material';
import {MRT_ColumnDef} from 'material-react-table';

import {
  formatOnboardingType,
  Onboarding,
  useGetOnboardings,
} from '@entities/onboarding';
import {MrTable} from '@shared/components';
import {
  entityTableCommonProps,
  ROUTE__ONBOARDING_DETAILS,
} from '@shared/constants';
import {Header} from '@widgets/common';

const columns: MRT_ColumnDef<Onboarding>[] = [
  {
    accessorKey: 'type',
    header: 'Type',
    enableSorting: false,
    Cell: ({row}) => (
      <Link
        component={RouterLink}
        to={ROUTE__ONBOARDING_DETAILS.replace(':type', row.original.type)}
      >
        {formatOnboardingType(row.original.type)}
      </Link>
    ),
  },
  {
    accessorKey: 'config',
    header: 'Config',
    enableSorting: false,
    Cell: ({row}) => (
      <Link
        href={row.original.config}
        target="_blank"
        rel="noopener noreferrer"
      >
        {row.original.config}
      </Link>
    ),
  },
  {
    accessorKey: 'geoConfigsCount',
    header: 'Geo configs',
    size: 120,
    enableSorting: false,
  },
];

export const OnboardingsPage = () => {
  const {data = [], isPending, error} = useGetOnboardings();

  return (
    <>
      <Header title="Onboarding" mb={1} isBackButtonShown={false} />

      <MrTable
        error={error}
        columns={columns}
        data={data}
        state={{isLoading: isPending}}
        {...entityTableCommonProps}
        enableRowActions={false}
      />
    </>
  );
};
